module.exports = __webpack_public_path__ + "img/iss-logo.b22c391c.svg";